import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Combobox } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { useRefSize } from "app/pages/digital-marketing/keywords-campaigns/shared/hooks";

import { TriggerInput, Chip, ChipsWrapper } from "./styles";
import type { ComboboxWithChipsProps } from "./types";

export type { ComboboxWithChipsProps } from "./types";

const TRIGGER_HEIGHT_IN_PX = 50;

export const ComboboxWithSelectedChips = ({
    isOpen = false,
    placement = "bottom-start",
    triggerIconName = "keywords",
    onOpenChange,
    placeholder,
    selectedChips,
    onCloseChip,
    strikethroughChips,
    searchValue,
    onSearchValueChange,
    children,
    ...rest
}: ComboboxWithChipsProps) => {
    const { ref: triggerRef, size: triggerSize } = useRefSize();

    return (
        <div data-automation="combobox-with-selected-chips">
            {selectedChips.length > 0 ? (
                <ChipsWrapper>
                    {selectedChips.map((tag) => (
                        <Chip
                            key={tag}
                            $strikethrough={strikethroughChips}
                            onCloseItem={onCloseChip ? () => onCloseChip(tag) : undefined}
                            text={tag}
                        />
                    ))}
                </ChipsWrapper>
            ) : null}
            <Combobox
                data-react-aria-top-layer="true"
                isOpen={isOpen}
                onOpenChange={onOpenChange}
                placement={placement}
                offset={-TRIGGER_HEIGHT_IN_PX} // to overlap the trigger
                width={triggerSize?.width ? `${triggerSize.width}px` : undefined}
                {...rest}
            >
                <Combobox.Trigger ref={triggerRef}>
                    <TriggerInput $hasTagsAbove={selectedChips.length > 0}>
                        <SWReactIcons
                            iconName={triggerIconName}
                            size="sm"
                            iconColor={colorsPalettes.carbon["200"]}
                        />
                        <Text
                            fontVariant="input2"
                            color={searchValue ? colorsPalettes.carbon["500"] : colorsPalettes.carbon["100"]}
                        >
                            {searchValue || placeholder}
                        </Text>
                    </TriggerInput>
                </Combobox.Trigger>

                <Combobox.SearchInput
                    icon="search"
                    value={searchValue}
                    placeholder={placeholder}
                    onChange={onSearchValueChange}
                />

                {children}
            </Combobox>
        </div>
    );
};
